export default __webpack_public_path__ + "static/media/image.gdcreations.e00806cd.png";